/**
 * @file formItem radio
 * @author zhaomiaoyuan
 * direction 方向，vertical-纵向，默认横向
 */
import React from 'react';
import LabelFormItem from '../LabelFormItem/index';
import Radio from 'antd/lib/radio';
import Space from 'antd/lib/space';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';

import './index.less';

interface OptionsItemProps {
    label: string;
    value: string | number;
}

interface Props {
    type: string;
    options: OptionsItemProps[];
    data: any;
    updateData?: any;
    isMsgRequired: boolean;
    title: string;
    onChange?: any;
    direction?: string;
}

export default function InputFormItem(props: Props) {
    const {
        type,
        options=[],
        data,
        updateData,
        isMsgRequired,
        title,
        direction,
        onChange
    } = props;

    const onRadioChange = e => {
        updateData && updateData({
            [type]: e.target.value
        });
        onChange && onChange(e);
    };
    return (
        <div className={'form-item-radio'}>
            <LabelFormItem isMsgRequired={isMsgRequired} title={title} />
            <Radio.Group onChange={onRadioChange} value={data[type]}>
                {
                    direction === 'vertical'
                        ? <Space direction="vertical">
                            {options.map((item: OptionsItemProps, index: number) =>
                                <Radio key={index} value={item.value}>{item.label}</Radio>)}
                        </Space>
                        : options.map((item: OptionsItemProps, index: number) =>
                            <Radio key={index} value={item.value}>{item.label}</Radio>)
                }
            </Radio.Group>

            {data[type + 'Err'] && <p className="form-item-radio-err">
                <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                {data[type + 'Err']}</p>}
        </div>
    );
}
